module.exports = __webpack_public_path__ + "img/odt.5486f0bc.svg";